query GetContactFormSubmissions($id: ID!) {
    contact(id: $id) {
        id
        name
        htmlUrl
        initials
        avatarUrl
        submissions {
            edges {
                node {
                    id
                    formVersion {
                        id
                        form {
                            id
                            name
                            htmlUrlPath
                        }
                    }
                    submissionTime
                    submissionUrl
                    fields {
                        edges {
                            node {
                                id
                                label
                                isRequired
                            }
                            fieldValue {
                                ... on FormFieldSubmissionValueMultiple {
                                    values
                                }
                                ... on FormFieldSubmissionValueSingle {
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
